import { Modal } from "react-bootstrap";
import { TextField } from "@mui/material";

const UtilizationUcOtpModal = ({
  open,
  onClose,
  otp,
  onOtpChange,
  onSubmit,
  loading = false,
}) => (
  <Modal
    show={open}
    onHide={onClose}
    centered
    backdrop="static"
    enforceFocus
    restoreFocus
    className="utilization-uc-otp-modal"
    dialogClassName="utilization-uc-otp-modal__dialog"
  >
    <Modal.Header closeButton>
      <Modal.Title>Verify OTP</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="utilization-uc-otp-modal__subtitle">
        OTP has been sent to the L3 user. Please enter OTP to generate the
        utilization certificate.
      </p>
      <TextField
        fullWidth
        label="Enter OTP"
        value={otp}
        onChange={(e) => onOtpChange(e.target.value)}
        inputProps={{ inputMode: "numeric", maxLength: 6 }}
        disabled={loading}
        autoFocus
        className="utilization-uc-otp-modal__input"
      />
    </Modal.Body>
    <Modal.Footer>
      <button
        type="button"
        className="utilization-uc-modal__btn utilization-uc-modal__btn--cancel"
        onClick={onClose}
        disabled={loading}
      >
        Cancel
      </button>
      <button
        type="button"
        className="utilization-uc-modal__btn utilization-uc-modal__btn--generate"
        onClick={onSubmit}
        disabled={loading}
      >
        {loading ? "Generating..." : "Verify & Generate Certificate"}
      </button>
    </Modal.Footer>
  </Modal>
);

export default UtilizationUcOtpModal;
